// extracted by mini-css-extract-plugin
export default {"tenantlist":"TenantList_tenantlist__F2vVI"};